<div class="transport-options-editor no-field-space">
  <sc-padding>
    <form [formGroup]="optionFormGroup">

      <mat-slide-toggle formControlName="onlyInternal" name="onlyInternal">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.only-internal"></sc-dictionary-label>
      </mat-slide-toggle>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-slide-toggle formControlName="readOnlyAtTerminal" name="readOnlyAtTerminal">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.readOnlyAtTerminal"></sc-dictionary-label>
      </mat-slide-toggle>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.color"></sc-dictionary-label>
        </mat-label>
        <app-color-picker (colorSelected)="colorPickerChanged($event)" formControlName="colorPickerColor" />
      </mat-form-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-slide-toggle formControlName="globalConnectNotificationsEnabled" name="globalConnectNotificationsEnabled">
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.global-connect-notifications-enabled"></sc-dictionary-label>
      </mat-slide-toggle>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-slide-toggle formControlName="noProcessingTimeThreshold" name="noProcessingTimeThreshold">
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.no-processing-time-threshold"></sc-dictionary-label>
      </mat-slide-toggle>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-number-field formControlName="permittedProcessingTime"
        labelDictionaryKey="tmc-yard.entity.transport-option.permitted-processing-time">
      </sc-number-field>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
      <mat-slide-toggle formControlName="preventGapsOnMultipleSlots" name="preventGapsOnMultipleSlots">
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.prevent-gaps-on-multiple-slots"></sc-dictionary-label>
      </mat-slide-toggle>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>
          <sc-dictionary-label
            dictionaryKey="tmc-yard.entity.transport-option.booking-offset-type"></sc-dictionary-label>
        </mat-label>
        <mat-select formControlName="bookingOffsetType">
          @for (bookingOffsetType of bookingOffsetTypeOptions; track bookingOffsetType) {
          <mat-option [value]="bookingOffsetType">
            <sc-dictionary-label
              dictionaryKey="tmc-yard.entity.transport-option.booking-offset-type.{{bookingOffsetType}}"></sc-dictionary-label>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <sc-content-spacer vertical></sc-content-spacer>

      @if (this.transportOption.bookingOffsetType === bookingOffsetType.HOURS) {
      <sc-number-field formControlName="bookingOffsetHours"
        labelDictionaryKey="tmc-yard.entity.transport-option.booking-offset-hours">
      </sc-number-field>
      }

      @if (this.transportOption.bookingOffsetType === bookingOffsetType.TIME_AND_WORKDAYS) {
      <sc-time-field formControlName="bookingOffsetTime" [required]="true"
        [label]="'booking offset time' | translate: ['tmc-yard.entity.transport-option.booking-offset-time', translationService.language, translationService.revision]"></sc-time-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-number-field formControlName="bookingOffsetDays"
        labelDictionaryKey="tmc-yard.entity.transport-option.booking-offset-days"></sc-number-field>
      }

      @if (this.transportOption.bookingOffsetType === bookingOffsetType.WEEKDAY_AND_WEEK_OFFSET) {
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>
          <sc-dictionary-label
            dictionaryKey="tmc-yard.entity.transport-option.booking-offset-weekday"></sc-dictionary-label>
        </mat-label>
        <mat-select formControlName="bookingOffsetWeekday">
          @for (bookingOffsetWeekday of weekdays; track bookingOffsetWeekday) {
          <mat-option [value]="bookingOffsetWeekday">
            <sc-dictionary-label
              dictionaryKey="common.common.enum.weekday.{{bookingOffsetWeekday}}"></sc-dictionary-label>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-time-field formControlName="bookingOffsetTime" [required]="true"
        [label]="'booking offset time' | translate: ['tmc-yard.entity.transport-option.booking-offset-time', translationService.language, translationService.revision]"></sc-time-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-number-field formControlName="bookingOffsetWeeks"
        labelDictionaryKey="tmc-yard.entity.transport-option.booking-offset-weeks"></sc-number-field>
      }

    </form>
  </sc-padding>
</div>
